export function resolvePromise(prms, promiseState){
    promiseState.promise = prms
    promiseState.data = null
    promiseState.error = null

    function dataACB(d){
        if(promiseState.promise === prms){
            promiseState.data = d   
        }    
    }
    
    function errorACB(e){
        if(promiseState.promise === prms){
            promiseState.error = e
        }
    }
    
    if(prms != null){
        prms.then(dataACB).catch(errorACB)
        return promiseState
    }
}
   

